<template>
    <div class="search-bar search-bar-center template1">
        <div class="search-by-section">
            <div class="search-category">
                <div class="keyword">
                    <i class="iconfont icon-search" aria-hidden="true"></i>
                    <input
                        class="search-input"
                        type="text"
                        v-model="keyword"
                        :placeholder="searchPlaceholder"
                        :aria-label="searchPlaceholder || 'Search keyword'"
                        @input="inputValue"
                        @click="setshowSearchList(true, $event)"
                        @keyup.enter="handleEnter"
                    />
                </div>
                <div
                    class="keyword-submit"
                    role="button"
                    tabindex="0"
                    :aria-label="submitText || 'Search'"
                    @click="handleSearch"
                >
                    {{ submitText || $t('md-hero.search') }}
                </div>
            </div>

            <ul
                class="search-list-panel mg-scrollbar"
                v-show="showSearchList && keyWordSuggestion.length > 0"
                v-outsideclick="outsideClick"
            >
                <li
                    v-for="(item, index) in keyWordSuggestion"
                    :class="`search-list-item ${
                        item.value ? 'item-type' : 'item-title'
                    }`"
                    :key="index"
                    @click="selectSuggestion(item.value, item.type)"
                >
                    {{ item.label }}
                </li>
            </ul>
        </div>
        <div
            class="condition-search"
            v-if="needSearchCondition && filteredConfigs.length > 0"
        >
            <ul class="condition-wrap">
                <li
                    v-for="item in filteredConfigs"
                    :class="`condition-item ${
                        item.name === 'price' ? 'condition-item-price' : ''
                    }`"
                    :key="item.name"
                >
                    <!-- <div v-if="item.type === 0"></div> -->
                    <div
                        class="condition-price"
                        v-if="
                            item.inputType == 'inputBox' &&
                                item.name === 'price'
                        "
                    >
                        <div class="price-input-wrap">
                            <p class="cell-title">
                                {{ item.args && item.args.minTitle }}
                            </p>
                            <input
                                class="price-input"
                                type="text"
                                v-model="startPrice"
                                @input="inputPrice('startPrice', $event)"
                                @click="
                                    showPriceList('showStartPriceList', $event)
                                "
                                @blur="switchPrice"
                                maxlength="13"
                                :placeholder="
                                    (priceConfig.args &&
                                        priceConfig.args.minTitle) ||
                                        ''
                                "
                                :aria-label="
                                    (priceConfig.args &&
                                        priceConfig.args.minTitle) ||
                                        'Minimum price'
                                "
                            />
                            <ul
                                class="price-list-panel"
                                v-show="showStartPriceList"
                                v-outsideclick="closeStartPriceListPannel"
                            >
                                <li @click="setPriceRange('startPrice', '')">
                                    <span>{{ $t('md-hero.any') }}</span>
                                </li>
                                <li
                                    v-for="price in item.args.options[0]"
                                    :key="price.value"
                                    @click="
                                        setPriceRange('startPrice', price.value)
                                    "
                                >
                                    <span>{{
                                        $ft.formatCurrency({
                                            value: price.label,
                                            currencySymbol
                                        })
                                    }}</span>
                                </li>
                            </ul>
                        </div>
                        <span class="price-line"></span>
                        <div class="price-input-wrap">
                            <!-- TODO -->
                            <p class="cell-title">{{ item.args.maxTitle }}</p>
                            <input
                                class="price-input"
                                type="text"
                                v-model="endPrice"
                                @input="inputPrice('endPrice', $event)"
                                @click="showPriceList('showEndPriceList',$event)"
                                @blur="switchPrice"
                                maxlength="13"
                                :placeholder="
                                    (priceConfig.args &&
                                        priceConfig.args.maxTitle) ||
                                        ''
                                "
                                :aria-label="
                                    (priceConfig.args &&
                                        priceConfig.args.maxTitle) ||
                                        'Maximum price'
                                "
                            />
                            <ul
                                class="price-list-panel end-panel"
                                v-show="showEndPriceList"
                                v-outsideclick="closeEndPriceListPannel"
                            >
                                <li @click="setPriceRange('endPrice', '')">
                                    <span>{{ $t('md-hero.any') }}</span>
                                </li>
                                <li
                                    v-for="price in item.args.options[1]"
                                    :key="price.value"
                                    @click="
                                        setPriceRange('endPrice', price.value)
                                    "
                                >
                                    <span>{{
                                        $ft.formatCurrency({
                                            value: price.label,
                                            currencySymbol
                                        })
                                    }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <template v-else>
                        <p class="cell-title">{{ item.label }}</p>
                        <Range
                            v-if="item.inputType == 'inputBox'"
                            cls="search-detail-item"
                            :emptyLabel="$t('md-hero.any')"
                            :label="item.label"
                            :kee="item.name"
                            :key="item.name"
                            :args="item.args"
                            :icon="item.icon"
                            :mask="item.mask"
                            :dropdown="true"
                            :heroCenter="true"
                            :value="
                                (conditions[item.name] &&
                                    conditions[item.name].value) ||
                                    ''
                            "
                            @change="updateCondition"
                            @open="
                                showStartPriceList = showEndPriceList = false
                            "
                            maxlength="9"
                        />
                        <Select
                            v-if="
                                item.inputType == 'multiSelect' ||
                                    item.inputType == 'singleSelect'
                            "
                            cls="search-detail-item"
                            :multiple="item.inputType == 'multiSelect'"
                            :label="item.label"
                            :kee="item.name"
                            :key="item.name"
                            :options="item.args"
                            :icon="item.icon"
                            :show_count="true"
                            :showAny="true"
                            :value="
                                (conditions[item.name] &&
                                    conditions[item.name].value) ||
                                    ''
                            "
                            :getOptionsAsync="true"
                            @changeOptions="
                                list => {
                                    changeOptions(list, item);
                                }
                            "
                            @change="updateCondition"
                            @open="
                                showStartPriceList = showEndPriceList = false
                            "
                        />
                    </template>
                </li>
            </ul>
        </div>
        <div
            class="keyword-submit"
            role="button"
            tabindex="0"
            :aria-label="submitText || 'Search'"
            @click="handleSearch"
        >
            {{ submitText || $t('md-hero.search') }}
        </div>
        <div
            v-if="agreementData && agreementData.agreement"
            class="agreement-container"
        >
            <a
                :href="agreementData.agreementUrl || ''"
                class="agreement"
                target="_blank"
                rel="noopener noreferrer"
            >{{ agreementData.agreement }}</a>
        </div>
    </div>
</template>

<script>
import common from '../search-bar-center';
export default {
    mixins: [common],
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';

.search-bar.template1 {
    width: 100%;
    position: relative;
    margin-top: 30px;
    > .keyword-submit {
        display: none;
        margin-top: 20px;
        border-top-left-radius: 2px;
        border-bottom-left-radius: 2px;
    }
    .keyword-submit {
        @include color-button-hover();
        width: 120px;
        height: 50px;
        line-height: 50px;
        padding: 0 10px;
        font-size: 16px;
        font-family: var(--mg-button-font);
        white-space: nowrap;
        overflow: hidden;
        border-top-right-radius: 2px;
        border-bottom-right-radius: 2px;
        text-align: center;
        cursor: pointer;
        @include color-button();

        .icon-search {
            margin-right: 6px;
        }
    }
    @include media-min-1080 {
        &.row {
            width: 400px;
            margin-top: 0;
            .search-category {
                .search-input {
                    border-top-right-radius: 2px;
                    border-bottom-right-radius: 2px;
                }
                .keyword-submit {
                    display: none;
                }
            }
            > .keyword-submit {
                display: block;
                width: 100%;
                margin-top: 20px;
            }
            .condition-search {
                margin-top: 5px;
                .condition-wrap {
                    flex-wrap: wrap;
                    .condition-item {
                        min-width: calc(50% - 30px);
                        max-width: 100%;
                        margin-top: 15px;
                        &.condition-item-price {
                            min-width: calc(100% - 30px);
                        }
                    }
                }
            }
        }
    }
    input[type='text'] {
        font-family: var(--font-normal);
        box-shadow: none;

        &:focus {
            outline: none;
            border: 1px solid var(--color-border);
        }
    }
    .search-by-section {
        position: relative;
        width: 100%;
        margin: 0 auto;

        .search-category {
            display: flex;
            align-items: center;
            height: 50px;
            font-size: 14px;
            line-height: 50px;
            .keyword {
                flex: 1;
                height: 100%;
                position: relative;
                .icon-search {
                    position: absolute;
                    left: 16px;
                    top: 50%;
                    transform: translateY(-50%);
                    font-size: 20px;
                    color: #c6c8d1;
                }
                @include placeholderMix(var(--font-normal), '#c6c8d1');
                .search-input {
                    width: 100%;
                    height: 50px;
                    padding-left: 51px;
                    font-size: 14px;
                    line-height: 14px;
                    color: #202437;
                    border: none;
                    outline: none;
                    box-shadow: none;
                    text-overflow: ellipsis;
                    -webkit-appearance: none;
                    border-top-left-radius: 2px;
                    border-bottom-left-radius: 2px;
                    //@include color-button-border();
                    &:focus {
                        @include color-button-border();
                    }
                }
            }
        }

        .address-input {
            width: 100%;
            margin: 0;
        }

        .search-list-panel {
            z-index: 1000;
            position: absolute;
            left: 0;
            top: 50px;
            padding: 10px 0;
            width: 100%;
            max-height: 300px;
            overflow-y: auto;
            background-color: #fff;
            //border: 1px solid var(--color-border);
            box-shadow: 0 2px 5px 0 rgba(0, 10, 30, 0.1);

            .search-list-item {
                height: 32px;
                line-height: 32px;
                color: #202437;
                @include ellipsis();
                &.item-title {
                    text-transform: capitalize;
                    font-family: var(--font-medium);
                    padding-left: 10px;
                }

                &.item-type {
                    padding: 0 10px 0 20px;
                    cursor: pointer;
                    &:hover {
                        background-color: #f6f7fb;
                    }
                }
            }
        }
    }

    .condition-search {
        width: 100%;
        margin-top: 50px;

        .condition-wrap {
            width: calc(100% + 30px);
            margin-left: -15px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: nowrap;
            font-size: 14px;
            color: #515666;

            .condition-item {
                margin-left: 15px;
                margin-right: 15px;
                flex: 1;
                width: 0;
                position: relative;

                &:first-child {
                    &:before {
                        width: 0;
                    }
                }

                .cell-title {
                    font-family: var(--font-medium);
                    font-size: 16px;
                    line-height: 1.25;
                    margin-bottom: 10px;
                    color: white;
                    white-space: nowrap;
                }

                .search-detail-item {
                    background-color: white;
                    border-radius: 2px;
                    border: solid 1px #e1e2e6;
                    min-width: 120px;
                    color: #202437;
                    position: relative;
                    height: 40px;
                    line-height: 38px;
                    align-items: center;

                    @media (min-width: 1260px) and (max-width: 1440px) {
                        min-width: 85px;

                        &.select {
                            min-width: 100px;
                        }
                    }

                    .name {
                        display: none;
                    }

                    .box-div {
                        width: 100%;
                        height: 100%;
                        padding: 0 10px;

                        .title {
                            height: 100%;
                            flex: 1;
                            overflow: hidden;
                            display: flex;
                            cursor: pointer;
                            .text {
                                flex: 1;
                                color: #515666;
                                @include ellipsis();
                            }
                            span:last-child {
                                float: right;
                                margin-right: 0;
                            }

                            .icon-arrow-down {
                                font-size: 10px;
                                color: #c6c8d1;
                            }

                            .logo {
                                display: none;
                            }
                        }

                        .panel-style {
                            position: absolute;
                            left: -1px;
                            z-index: var(--level-subhigh);
                            width: calc(100% + 2px);
                            min-width: 85px;
                            max-height: 300px;
                            padding: 10px 0;
                            overflow-y: auto;
                            color: rgb(40, 40, 40);
                            background: #fff;
                            box-shadow: 0 2px 5px 0 rgba(0, 10, 30, 0.1);
                            border: 1px solid var(--color-border);
                            box-sizing: border-box;
                            color: #202437;

                            li {
                                line-height: 32px;
                                padding: 0 0 0 10px;
                                cursor: pointer;
                                height: 32px;
                                display: block;
                                overflow: hidden;

                                & > span {
                                    display: inline-block;
                                    width: calc(100% - 30px);

                                    @include ellipsis();
                                }

                                .iconfont {
                                    display: none;
                                    float: right;
                                    padding-right: 14px;
                                    font-size: 12px;
                                }

                                &:hover {
                                    background-color: #f6f7fb;
                                }

                                &.selected {
                                    @include color-button-color();

                                    .iconfont {
                                        display: block;
                                    }
                                }
                            }
                        }

                        .split-line {
                            height: 30px;
                            width: 1px;
                            background-color: var(--color-border);
                        }

                        .range-input-parent {
                            width: calc(100% - 50px);

                            &.box-div {
                                display: flex;
                                align-items: center;
                                cursor: auto;

                                .text {
                                    margin-right: 6px;
                                    cursor: default;
                                    flex: inherit;
                                }
                            }

                            &.list-panel {
                                position: absolute;
                                z-index: 1000;
                                display: flex;
                                justify-content: space-between;
                                left: 0;
                                width: 316px;
                                padding: 20px;
                                box-shadow: 0 2px 5px 0 rgba(0, 10, 30, 0.1);
                                border: 1px solid var(--color-border);
                                background-color: #fff;

                                .input-container {
                                    width: 120px;
                                    margin: 0;
                                    line-height: normal;
                                    .input-label {
                                        line-height: 16px;
                                        font-size: 14px;
                                        margin-bottom: 8px;
                                    }
                                    .list-panel {
                                        position: relative;
                                        top: 0;
                                        left: 0;
                                        margin-top: 10px;
                                        padding: 0;
                                        border: none;
                                        box-shadow: none;

                                        &.disabled {
                                            display: none;
                                            cursor: not-allowed;
                                            color: var(--color-holder);

                                            &:after {
                                                content: '';
                                                position: absolute;
                                                top: 0;
                                                left: 0;
                                                width: 100%;
                                                height: 100%;
                                                z-index: 1;
                                            }
                                        }

                                        li {
                                            padding: 0 10px;
                                            height: 32px;
                                            line-height: 32px;

                                            &:hover {
                                                background-color: #f6f7fb;
                                            }

                                            span {
                                                width: 100%;
                                                padding: 0;
                                            }
                                        }
                                    }
                                }

                                .price-line {
                                    margin-top: 15px;
                                }
                            }

                            .price-line {
                                display: none;
                                width: 6px;
                                height: 1px;
                                background-color: var(--color-holder);
                                display: inline-block;
                                vertical-align: middle;
                                margin: 0 5px;
                            }

                            .input-container {
                                position: relative;
                                height: 100%;
                                margin: 0 10px;

                                .list-panel {
                                    left: 0;
                                    right: -50px;
                                    width: inherit;
                                }

                                input {
                                    width: 120px;
                                    height: 30px;
                                    padding: 0 10px;
                                    color: #202437;
                                    line-height: 14px;
                                }

                                &.show-list {
                                    input {
                                        outline: none;
                                        border: 1px solid;
                                        @include color-theme('border-color');
                                    }
                                }

                                &.input_1 {
                                    margin-right: 0;
                                }
                            }
                        }
                    }
                }
                &.condition-item-price {
                    flex: 2;
                }
            }

            .condition-price {
                display: flex;
                align-items: center;
                .price-title {
                    margin-right: 6px;
                }

                .price-input-wrap {
                    flex: 1;
                    position: relative;
                    .price-input {
                        width: 100%;
                        height: 40px;
                        border-radius: 2px;
                        border: solid 1px #e1e2e6;
                        padding: 0 10px;
                        font-size: 14px;
                        line-height: 18px;
                        color: #515666;
                        &::-webkit-input-placeholder {
                            color: #515666;
                        }
                        &::-moz-placeholder {
                            color: #515666;
                        }
                        &:-moz-placeholder {
                            color: #515666;
                        }
                        &:focus {
                            @include color-theme('border-color');
                        }
                    }

                    .price-list-panel {
                        position: absolute;
                        top: 70px;
                        left: 0;
                        width: 100%;
                        max-height: 300px;
                        overflow-y: auto;
                        background-color: #fff;
                        z-index: var(--level-subhigh);
                        li {
                            padding: 0 10px;
                            height: 32px;
                            line-height: 32px;
                            overflow: hidden;
                            cursor: pointer;

                            &:hover {
                                background-color: #f6f7fb;
                            }
                        }
                    }
                }

                .price-line {
                    display: inline-block;
                    vertical-align: middle;
                    width: 16px;
                    height: 2px;
                    margin: 49px 7px 19px;
                    opacity: 0.6;
                    background-color: #fff;
                }
            }
        }
    }
    .agreement-container {
        width: 100%;
        margin-top: 20px;
        .agreement {
            width: 100%;
            font-size: 12px;
            text-align: center;
            @include webkitBox(3);
            line-height: 14px;
            color: #fff;
            &:hover {
                @include color-hover();
                @include media-800 {
                    color: #fff;
                }
            }
        }
    }
    @include media-800 {
        .search-by-section {
            .search-category {
                height: 40px;
                line-height: 40px;
                .keyword {
                    .icon-search {
                        left: 10px;
                    }
                    .search-input {
                        height: 40px;
                        padding-left: 34px;
                    }
                }
                .keyword-submit {
                    font-size: 12px;
                    width: auto;
                    padding: 0 10px;
                    height: 40px;
                    line-height: 40px;
                }
            }
        }
        .condition-search {
            display: none;
        }
    }
}
</style>
